var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageloading-wrapper"},[_c('div',{staticClass:"pageLoading",class:[_vm.white ? 'pageLoading--white': '']})])
}
var staticRenderFns = []

export { render, staticRenderFns }